{
  "title": "Sequester",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level transmutation",
  "level": 7,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a powder composed of diamond, emerald, ruby, and sapphire dust worth at least 5,000 gp, which the spell consumes)",
  "duration": "Until dispelled",
  "description": [
    "By means of this spell, a willing creature or an object can be hidden away, safe from detection for the duration. When you cast the spell and touch the target, it becomes invisible and can’t be targeted by divination spells or perceived through scrying sensors created by the divination of spells.",
    "If the target is a creature, it falls into a state of suspended animation. Time ceases to flow for it, and it doesn’t grow older.",
    "You can set a condition for the spell to end early. The condition can be anything you choose, but it must occur or be visible within 1 mile of the target. Examples include \"after 1,000 years\" or \"when the tarrasque awakes.\" This spells also ends if the target takes any damage."
  ],
  "spellLists": ["wizard"]
}
